import { mainFetchUrl } from "../constants/urls";
import { createSearchParams, FetchFunction } from "./util";

export const searchMovies = (fetchFunction: FetchFunction, searchQuery: string, year: number = 0, page: number = 0) => {
  const searchParams = createSearchParams();
  searchParams.append("query", searchQuery);
  if (year > 0) searchParams.append("year", `${year}`);
  if (page > 0) searchParams.append("page", `${page}`);
  return fetchFunction(`${mainFetchUrl}/search/movie?${searchParams.toString()}`);
};
